import { Component, Input } from '@angular/core';

export interface GaugeArc {
  path: string;
  color: string;
}

@Component({
  selector: 'gauge-svg',
  standalone: false,
  templateUrl: './gauge-svg.component.html',
  styleUrl: './gauge-svg.component.scss'
})
export class GaugeSvgComponent {
  @Input() gaugeSize = 200;
  @Input() strokeWidth = 20;
  @Input() arcs: GaugeArc[] = [];
  @Input() backgroundPath = '';
  @Input() backgroundStroke = '#eff2f5';
}
